<template>
    <div>
      <h2 class="mb-4" >
        <b-alert show variant="info">
        <b-badge class=" signs mr-2" variant="success">Angebote</b-badge>&<b-badge class="signs ml-2" variant="danger">Rabatte</b-badge> Nur für kurze Zeit
        </b-alert>
      </h2>

      <luma-datatable :url="url"
                      :columns="columns"
                      :model="domain"
                      :order="order"  >
      </luma-datatable>
    </div>
</template>

<script>
    import LumaDatatable from "@/components/LumaDatatable"
    import DomainPriceDisount from "@/store/models/domain/domain_price_discount"
    export default {
        components:{LumaDatatable},
        name: "domain-discount-list",
        data:()=>({
          url: "/accounting/pricing/domains/discounts",

            domain: DomainPriceDisount,
            order:{
                'tld': 'asc'
            }


        }),

        computed:{

            columns(){
                const headers = ['tld', 'start_date', 'end_date', 'years', 'price', 'type']

                return headers.map(el=>({
                    key:el,
                    column:el,
                    filter:true,
                    order:true,
                    format: el === 'price' ? 'currency':''
                }
                ))

            }
        }
    }
</script>

<style scoped>

  .signs{
    font-size: large;
  }

</style>



// WEBPACK FOOTER //
// src/components/domain/price_domain/domain-discount-list.vue